/* @flow */
import React from 'react';
import classnames from 'classnames';
// Styles
import styles from './styles.scss';

type InternalSellerNameProps = {|
    sellerName: string,
    isSbTile?: boolean,
|};

export function InternalSellerName({ sellerName, isSbTile }: InternalSellerNameProps) {
    return (
        <div
            className={classnames(styles.internalByline, {
                [styles.isSbTile]: isSbTile,
            })}
            data-tn="internal-seller-name"
        >
            {sellerName}
        </div>
    );
}

export default InternalSellerName;
